// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2421 ? "4286a96f" : chunkId) + "." + {"89":"86e2e42646c55fa8","1697":"f19680aa10fba006","2421":"d0ca4502c9f77c63","2650":"8ce3455b25e7c73d"}[chunkId] + ".js";
};